import { createAction } from "redux-ts";

import { createCsvFileRequestPayload } from "../../models";

export const createCsvFile = createAction<createCsvFileRequestPayload>(
    "REPORTS::CREATE_CSV_FILE"
);
